import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import { createContext, useContext, useRef, useState } from "react";

const AuthContext = createContext();

export default function AuthContextProvider({ children }) {
  const amountInp = useRef();
  const gets = useRef();
  const total = useRef();
  const [user, setuser] = useState(
    Cookies.get("token") && jwt_decode(Cookies.get("token"))?.user  );
  return <AuthContext.Provider value={{user, setuser, amountInp, total, gets}}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  return useContext(AuthContext);
}
